export const BUSINESS_BLOCKED_CODE = 'BUSINESS_BLOCKED';

export const BUSINESS_BLOCKED_MESSAGE =
  'Acesso bloqueado. Entre em contato com um administrador.';

/**
 * Reconhece o erro de negócio bloqueado vindo da API (login ou qualquer ação).
 * Preparado para o bloqueio automático por assinatura no futuro: basta a API
 * responder com o mesmo `code`.
 */
export function isBusinessBlockedError(error: unknown): boolean {
  const response = error as
    | { data?: { code?: string }; status?: number }
    | undefined;

  return response?.data?.code === BUSINESS_BLOCKED_CODE;
}
